import React from 'react'
import Footer from '../components/footerComponent/footer'
import Signup from '../components/signupComponent/signup'
import {Layout} from 'antd';

export default function RegisterPage() {
    return (
        <Layout>
            <Signup/>
            <Footer/>
        </Layout>
    );
};
